import Header from "../header/Header";
import AboutJosh from "./AboutJosh";
import Footer from "../footer/Footer";
import Contact from "../about-us/Contact";

const AboutUs = () => {
  return (
    <div>
      <Header />
      <AboutJosh />
      <Contact />
      <Footer />
    </div>
  );
};
export default AboutUs;
